// extracted by mini-css-extract-plugin
export default {"Panneau":"PanneauProduit_Panneau__05Ezc","BoutonTitre":"PanneauProduit_BoutonTitre__klujw"};